module.exports = __webpack_public_path__ + "static/old-web.0611ea4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/crossfader/old-web.png
// module id = 468
// module chunks = 261706647590803